import { Component, Input, Output, OnInit, EventEmitter, ViewChild, Sanitizer } from '@angular/core';
import { BrowserModule, DomSanitizer, SafeHtml } from '@angular/platform-browser'
import { SanitizeHtmlDirective } from '../app.taketestdirective';
declare var SetHintPropertyToQuestionObject: any, HintOneCultVal: any, HintTwoCultVal: any, HintThreeCultVal: any;
@Component({
    selector: 'app-hints',
    templateUrl: 'app.hints.html'
})
export class HintsCommonComponent {
    //from parent
    public HintOneVal: any = "";
    public HintTwoVal: any = "";
    public HintThreeVal: any = "";
    @Input() item: any;
    @Input() TestInfo: any;

    ngOnInit() {
        try {
            this.AssignResouceKeyValue();
        }
        catch (e) { }
    }
    ShowHints(item: any, valueId: any, event: any) {
        try {
            $('.question_hints_area').hide();
            $('.select_anchor').removeClass('question_hints_sel');
            $(event.currentTarget).addClass('question_hints_sel');
            $("#" + valueId + item.ID).show();
            item.IsHintsClicked = true;
            SetHintPropertyToQuestionObject(item);
        }
        catch (e) { }
    }
    AssignResouceKeyValue() {
        try {
            this.HintOneVal = HintOneCultVal;
            this.HintTwoVal = HintTwoCultVal;
            this.HintThreeVal = HintThreeCultVal;
        }
        catch (e) { }
    }
}



// WEBPACK FOOTER //
// E:/Workspace/TestandAssessment/Manifest/TestPlayer/TestDelivery.TestPlayer/src/app/Test/QuestionCommon/app.hints.ts